import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Paper,
  TextField,
  Button,
  Typography,
  Box,
  Alert,
  Link,
} from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import axios from 'axios';
import { COMPANY_INFO } from '../constants/company';

const Login = () => {
  const navigate = useNavigate();
  const { login, isAuthenticated } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [resetUsername, setResetUsername] = useState('');
  const [resetMessage, setResetMessage] = useState('');
  const [showReset, setShowReset] = useState(false);

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/users');
    }
  }, [isAuthenticated, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(username, password);
    if (result.success) {
      navigate('/users');
    } else {
      setError(result.error);
    }
    setLoading(false);
  };

  const handlePasswordReset = async (e) => {
    e.preventDefault();
    setResetMessage('');
    try {
      await axios.post('/api/auth/password-reset-request/', {
        username: resetUsername,
      });
      setResetMessage('Token de recuperación generado. Contacta al administrador para obtener el código.');
      setResetUsername('');
    } catch (error) {
      setResetMessage(
        error.response?.data?.error || 'Error al solicitar recuperación de contraseña'
      );
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Paper elevation={3} sx={{ padding: 4, width: '100%' }}>
          <Typography component="h1" variant="h4" align="center" gutterBottom>
            {COMPANY_INFO.NAME}
          </Typography>
          <Typography variant="body2" align="center" color="text.secondary" gutterBottom>
            Sistema de Administración
          </Typography>

          {!showReset ? (
            <>
              <Box component="form" onSubmit={handleSubmit} sx={{ mt: 3 }}>
                {error && (
                  <Alert severity="error" sx={{ mb: 2 }}>
                    {error}
                  </Alert>
                )}
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  label="Usuario"
                  autoComplete="username"
                  autoFocus
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                />
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  label="Contraseña"
                  type="password"
                  autoComplete="current-password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={{ mt: 3, mb: 2 }}
                  disabled={loading}
                >
                  {loading ? 'Iniciando sesión...' : 'Iniciar Sesión'}
                </Button>
                <Link
                  component="button"
                  type="button"
                  variant="body2"
                  onClick={() => setShowReset(true)}
                  sx={{ mt: 2 }}
                >
                  ¿Olvidaste tu contraseña?
                </Link>
              </Box>
            </>
          ) : (
            <>
              <Box component="form" onSubmit={handlePasswordReset} sx={{ mt: 3 }}>
                {resetMessage && (
                  <Alert
                    severity={resetMessage.includes('Error') ? 'error' : 'success'}
                    sx={{ mb: 2 }}
                  >
                    {resetMessage}
                  </Alert>
                )}
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  label="Usuario"
                  value={resetUsername}
                  onChange={(e) => setResetUsername(e.target.value)}
                />
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={{ mt: 3, mb: 2 }}
                >
                  Enviar Código por WhatsApp
                </Button>
                <Link
                  component="button"
                  type="button"
                  variant="body2"
                  onClick={() => {
                    setShowReset(false);
                    setResetMessage('');
                  }}
                  sx={{ mt: 2 }}
                >
                  Volver al login
                </Link>
              </Box>
            </>
          )}
        </Paper>
      </Box>
    </Container>
  );
};

export default Login;

